export default __webpack_public_path__ + "static/media/resume.2d10f392.pdf";